/**
 * Google Analytics contact tracking.
 *
 * Sends a GA4 event whenever a visitor tries to get in touch:
 *   - phone_click    clicking a tel: link
 *   - email_click    clicking the business email link
 *   - generate_lead  submitting the "Book a service" form (after browser validation passes)
 *
 * window.gtag is only present in production builds (gatsby-plugin-google-gtag).
 */

const BUSINESS_EMAIL = "machinery.masterton@mitre10.co.nz"

const track = (eventName, params) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, {
      page_path: window.location.pathname,
      ...params,
    })
  }
}

export const onClientEntry = () => {
  document.addEventListener("click", event => {
    const link = event.target.closest && event.target.closest("a[href]")
    if (!link) return

    const href = link.getAttribute("href")
    if (href.startsWith("tel:")) {
      track("phone_click", { link_url: href, link_text: link.textContent.trim() })
    } else if (href.startsWith("mailto:") && href.includes(BUSINESS_EMAIL)) {
      track("email_click", { link_url: href, link_text: link.textContent.trim() })
    }
  })

  document.addEventListener("submit", event => {
    if (event.target.getAttribute("name") === "contact") {
      track("generate_lead", { method: "contact_form" })
    }
  })
}
